import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=cc0d70be&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc0d70be')) {
      api.createRecord('cc0d70be', component.options)
    } else {
      api.reload('cc0d70be', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=cc0d70be&", function () {
      api.rerender('cc0d70be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-40IcAaI6eSUNO/JS/comp/FavElement.vue"
export default component.exports